module.exports = __webpack_public_path__ + "pv_resort.1a80ee50e5e293352850.jpg";


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/assets/images/pv_resort.jpg
// module id = ../../../../../src/assets/images/pv_resort.jpg
// module chunks = 39